import { render, staticRenderFns } from "./addLead.vue?vue&type=template&id=99fc2d98"
import script from "./addLead.vue?vue&type=script&lang=js"
export * from "./addLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports